import Vue from 'vue'
import './assets/icons'
import 'mint-ui/lib/style.css'
import './assets/styles/reset.css'
import './assets/styles/global.less'

import App from './App.vue'
import Router from 'vue-router'
import store from './store/index'
import { KDMessageBox } from 'kuaidong-ui'
import RAccount from './config/router/account'
import LoginService from './service/LoginService'
import { InfiniteScroll, Lazyload } from 'mint-ui'
import RPageNotFound from './config/router/page-not-found'

import {
  logger,
  UIUtil,
  VueUtil,
  AppUtil,
  HttpUtil,
  JSBridgeUtil,
  HttpUtilEvent,
  JSBridgeUtilEvent,
} from 'kuaidong-lib'

Vue.use(Router)
Vue.use(Lazyload)
Vue.use(InfiniteScroll)
Vue.config.productionTip = false
Vue.px = Vue.prototype.$px = VueUtil.getActualPx.bind(VueUtil)

AppUtil.init()
VueUtil.addVConsole()
VueUtil.setRem(VueUtil.setRemByMainEleId.bind(VueUtil), 'app')

HttpUtil.on(HttpUtilEvent.BeforeRequest, () => UIUtil.showLoading())
HttpUtil.on(HttpUtilEvent.AfterRequest, () => UIUtil.hideLoading())
HttpUtil.on(HttpUtilEvent.StatusCode401, () => LoginService.login())

JSBridgeUtil.on(JSBridgeUtilEvent.BeforeFunctionCall, async (methodName: string) => {
  if (
    !['finish', 'videoEvent', 'getUserToken', 'hideTitleBar', 'setNativeViewVisibility'].includes(methodName) &&
    !(await AppUtil.isUnderApp())
  ) {
    const ok = await KDMessageBox.confirm('该操作需要在天天跳绳App内进行。', '提示', {
      confirmButtonText: '打开App',
      confirmButtonType: 'danger',
    })

    if (ok) {
      AppUtil.openOrDownloadAppInH5()
    }
  }
})

export function createApp(router: Router) {
  LoginService.setRouter(router)

  router.beforeEach(LoginService.routerBeforeEachHook.bind(LoginService))

  // Need refactor LoginService to resolve the full path of the login page,
  // instead of add the login route to every single page app.
  for (const route of RAccount) {
    router.addRoute(route)
  }

  // Page not found. The routes must be added as the last routes.
  for (const route of RPageNotFound) {
    router.addRoute(route)
  }

  const v = new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')

  logger.init()
  logger.installCodelessTracking(v)
}
